import { Component, EventEmitter, Input, Output } from '@angular/core';
import { ActivatedRoute, ParamMap, Router } from '@angular/router';
import { ResizeService } from '../../services/resize.service';
import { CommonModule, CurrencyPipe } from '@angular/common';
import { DirectivesModule } from '../../tsExtras/directives.module';
import { CurrencyService } from '../../services/currency.service';

@Component({
  selector: 'app-package-card',
  standalone: true,
  imports: [DirectivesModule, CurrencyPipe, CommonModule],
  templateUrl: './package-card.component.html',
  styleUrl: './package-card.component.scss',
})
export class PackageCardComponent {
  @Input() package: any;
  @Input() subscribePackage: Function;
countryCode:String;
iscountryPK:boolean=false;
  isMobile: boolean = false;
  hoveredIndex: number = -1; // Track hovered card index

  constructor(public resize: ResizeService,private currencyService:CurrencyService) {
    this.resize.windowSize$.subscribe((size) => {
      // console.log('size: ', size);
      if (size.width <= 540) {
        this.isMobile = true;
      }
    });

       this.currencyService.getCountryCodeDefault().subscribe({
    next: (response: any) => {
      this.countryCode = response.country;
      if(this.countryCode=="PK"){
        this.iscountryPK=true;

      }
    },
    error: (err) => {
      console.error('Error getting country code:', err);
      this.countryCode = 'US'; 
    }
  });
  

  }

  handleMouseEnter(index: number): void {
    this.hoveredIndex = index;
  }

  handleMouseLeave(index: number): void {
    this.hoveredIndex = -1;
  }
}
